module.exports = __webpack_public_path__ + "img/814b5ed.jpg";